/* tslint:disable */
import {
  StockLocation,
  StockQuant,
  ProductionOrderOutLine
} from '../index';

declare var Object: any;
export interface StockQuantPackageInterface {
  "id"?: number;
  "name"?: string;
  "out_prod_line_ids"?: Array<any>;
  "quant_ids"?: Array<any>;
  "location_id"?: number;
  "package_ids"?: number;
  location?: StockLocation;
  quants?: StockQuant[];
  outProdLineIds?: ProductionOrderOutLine[];
}

export class StockQuantPackage implements StockQuantPackageInterface {
  "id": number;
  "name": string;
  "out_prod_line_ids": Array<any>;
  "quant_ids": Array<any>;
  "location_id": number;
  "package_ids": number;
  "epc_code": string;
  location: StockLocation;
  quants: StockQuant[];
  outProdLineIds: ProductionOrderOutLine[];
  constructor(data?: StockQuantPackageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockQuantPackage`.
   */
  public static getModelName() {
    return "StockQuantPackage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockQuantPackage for dynamic purposes.
  **/
  public static factory(data: StockQuantPackageInterface): StockQuantPackage{
    return new StockQuantPackage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockQuantPackage',
      plural: 'StockQuantPackages',
      path: 'StockQuantPackages',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "out_prod_line_ids": {
          name: 'out_prod_line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "quant_ids": {
          name: 'quant_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "package_ids": {
          name: 'package_ids',
          type: 'number'
        },
      },
      relations: {
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        quants: {
          name: 'quants',
          type: 'StockQuant[]',
          model: 'StockQuant',
          relationType: 'referencesMany',
                  keyFrom: 'quant_ids',
          keyTo: 'id'
        },
        outProdLineIds: {
          name: 'outProdLineIds',
          type: 'ProductionOrderOutLine[]',
          model: 'ProductionOrderOutLine',
          relationType: 'referencesMany',
                  keyFrom: 'out_prod_line_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockQuantPackage.ts